export const contactDetails = ({ contact: {
  address,
  fax,
  phone,
} }) => ({
  address,
  fax,
  phone,
});



// WEBPACK FOOTER //
// ./src/store/selectors/contact.js